export enum UserRoles {
    Admin = 'admin',
    ModelModerator = 'model-moderator',
    Manager = 'manager',
    Guest = 'guest',
    Member = 'member',
    LegalRepresentative = 'legal-representative',
}
